'use client';

import { ComponentRef, forwardRef, useMemo } from "react";
import { Button, ButtonOwnProps, ButtonProps, Typography } from "@mui/material";
import { ComponentContactPhone } from "@/app/lib/generated/graphql-types";
import { Phone } from "@mui/icons-material";
import parsePhoneNumber from "libphonenumber-js";

interface PhoneButtonProps {
    phone: ComponentContactPhone;
}

const PhoneButton = forwardRef<ComponentRef<typeof Button>, ButtonProps & ButtonOwnProps & PhoneButtonProps>(
    ({ phone, ...props }, ref) => {

        const telLinkAddress = useMemo(
            () => parsePhoneNumber(phone.number, 'DE')?.getURI(),
            [phone.number]
        );


        return (
            <Button
                ref={ref}
                {...props}
                className={`phone-button-root ${props.className}`}
                variant="outlined"
                startIcon={<Phone />}
                href={telLinkAddress}
                sx={{
                    ...props.sx,
                    px: 1.5,
                    position: 'relative',
                    justifyContent: 'center',
                    pl: (theme) => `calc(${theme.spacing(4)} + 4px)`,
                    '& .MuiButton-startIcon': {
                        position: 'absolute',
                        left: (theme) => theme.spacing(2),
                        marginRight: 0,
                    },
                    textAlignLast: 'center'
                }}
                fullWidth
            >
                <Typography
                    component="span"
                    noWrap
                    sx={{
                        color: 'inherit',
                        font: 'inherit',
                        minWidth: 0,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: 'block',
                        flexGrow: 1,
                    }}
                    title={phone.number}
                >
                    {phone.number}
                </Typography>
            </Button>
        );
    }
);

PhoneButton.displayName = 'PhoneButton';
export default PhoneButton;
